<p-dialog [(visible)]="addWaypointDialogVisible" [header]="dialogHeader" [modal]="true"
          [style]="{ width: 'min(720px, 94vw)' }" [breakpoints]="{ '640px': '96vw' }"
          styleClass="waypoint-edit-dialog" [draggable]="false" [resizable]="false"
          (onHide)="hideAddWaypointDialog()">
    <ng-container *ngIf="newWaypoint">
        <section class="waypoint-dialog-body">
            <aside class="waypoint-dialog-summary">
                <span class="waypoint-dialog-icon"><i class="fa-solid fa-route"></i></span>
                <div>
                    <small>Shipment route</small>
                    <h3>{{ sectionTitle }}</h3>
                    <p>{{ sectionSubtitle }}</p>
                </div>
            </aside>
            <div class="waypoint-dialog-form p-fluid">
            <app-page-form-section
                icon="fa-solid fa-route"
                [title]="sectionTitle"
                [subtitle]="sectionSubtitle">
                <div class="formgrid grid">
                    <div class="field col-12">
                        <p-inputGroup>
                            <p-inputGroupAddon><i class="fa-solid fa-map-pin"></i></p-inputGroupAddon>
                            <p-iftaLabel>
                                <p-select id="waypointLocation"
                                            name="waypointLocation"
                                            appLazyLocationPicker
                                            [(ngModel)]="newWaypoint.location"
                                            optionLabel="name"
                                            placeholder="Select a location"
                                            [filter]="true"
                                            [appendTo]="'body'"
                                            [showClear]="true"
                                            [required]="true"
                                            styleClass="w-full"
                                            [ngClass]="{'ng-invalid ng-dirty' : submittedWaypoint && (!newWaypoint.location || !hasValidCoordinates(newWaypoint.location))}">
                                </p-select>
                                <label for="waypointLocation">Waypoint Location</label>
                            </p-iftaLabel>
                            <p-inputGroupAddon>
                                <p-button icon="pi pi-plus" severity="secondary" ariaLabel="Create location" (onClick)="openLocationDialog()"></p-button>
                            </p-inputGroupAddon>
                            <p-inputGroupAddon *ngIf="newWaypoint.location?.id && canEditLocation">
                                <p-button icon="pi pi-pencil" severity="secondary" ariaLabel="Edit selected location and GPS coordinates"
                                    (onClick)="openLocationDialog(newWaypoint.location.id)"></p-button>
                            </p-inputGroupAddon>
                        </p-inputGroup>
                        <small class="p-error" *ngIf="submittedWaypoint && !newWaypoint.location">Location is required.</small>
                        <small class="p-error" *ngIf="newWaypoint.location && !hasValidCoordinates(newWaypoint.location)">This location needs valid latitude and longitude. Update it or choose another location.</small>
                    </div>
                    <div class="field col-12 return-waypoint-note" *ngIf="(isReturnMode || isDeliveryOnlyMode) && !isLocationOnlyMode">
                        <i class="fa-solid fa-rotate-left"></i>
                        <span>{{ isDeliveryOnlyMode ? 'This operational visit is appended to this delivery before an optional return-to-base leg.' : 'This optional stop is added as the final driver-return destination. It does not block shipment completion.' }}</span>
                    </div>
                    <div class="field col-12" *ngIf="!isLocationOnlyMode && !isReturnMode && !isDeliveryOnlyMode">
                        <p-inputGroup>
                            <p-inputGroupAddon><i class="fa-solid fa-dolly"></i></p-inputGroupAddon>
                            <p-iftaLabel>
                                <p-select id="waypointType"
                                            name="waypointType"
                                            [options]="waypointTypeOptions"
                                            [(ngModel)]="newWaypoint.waypointType"
                                            optionLabel="label"
                                            optionValue="value"
                                            placeholder="Select a type"
                                            [appendTo]="'body'"
                                            [showClear]="true"
                                            [required]="true"
                                            styleClass="w-full"
                                            [ngClass]="{'ng-invalid ng-dirty' : submittedWaypoint && !newWaypoint.waypointType}">
                                </p-select>
                                <label for="waypointType">Waypoint Type</label>
                            </p-iftaLabel>
                        </p-inputGroup>
                        <small class="p-error" *ngIf="submittedWaypoint && !newWaypoint.waypointType">Waypoint Type is required.</small>
                    </div>
                </div>
            </app-page-form-section>
            </div>
        </section>
    </ng-container>
    <ng-template pTemplate="footer">
        <div class="waypoint-dialog-footer">
            <p-button label="Cancel" icon="fa-solid fa-xmark" styleClass="p-button-text" (click)="hideAddWaypointDialog()"></p-button>
            <p-button [label]="saveButtonLabel" icon="fa-solid fa-check" (click)="saveNewWaypoint()" [loading]="addWaypointInProgress"></p-button>
        </div>
    </ng-template>
</p-dialog>
